import JsonLd from "./JsonLd";
import { useServerTranslation } from "@/app/i18n";
import { buildCampaignOffersSchema } from "@/lib/campaign-schema";
import unescapeHTML from "@/lib/unescape-html";

interface CampaignOffersJsonLdProps {
  site: Site.Site;
  campaigns: any;
  districtData?: any;
  serviceData?: any;
}

export default async function CampaignOffersJsonLd({
  site,
  campaigns,
  districtData,
  serviceData,
}: CampaignOffersJsonLdProps) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = await useServerTranslation("tr", "site");

  // The same keys the page heading uses, so a filtered list is named after what
  // the visitor actually sees ("Balgat Kampanyaları") instead of the whole city.
  // A district-only title leaves the service placeholder empty, hence the
  // whitespace collapse.
  const translate = (key: string) => {
    const value = t(key, {
      service: serviceData?.descriptions?.[0]?.title,
      district: districtData?.title,
    });

    if (!value || value === key) return undefined;

    return unescapeHTML(value).replace(/\s+/g, " ").trim() || undefined;
  };

  const getName = () => {
    if (!districtData?.id && serviceData?.id) {
      return translate("search-title-service-campaign");
    }

    if (districtData?.id && !serviceData?.id) {
      return translate("search-title-district-campaign");
    }

    if (districtData?.id && serviceData?.id) {
      return translate("search-title-district-and-service-campaign");
    }

    return translate("common-campaign-schema-name");
  };

  const schema = buildCampaignOffersSchema({
    site,
    campaigns: campaigns?.response,
    name: getName(),
  });

  if (!schema) return null;

  return <JsonLd id="campaign-offers-schema" data={schema} />;
}
